<template>
  <b-form @submit.prevent="onSubmit">
    <b-form-group class="required" label="Email">
      <b-input-group>
        <b-form-input
          v-model="username"
          autocomplete="off"
          :state="$v.username.$error? false : null"
          @input="$v.username.$reset()"
        ></b-form-input>
      </b-input-group>
    </b-form-group>

    <b-form-group class="required" label="Hasło">
      <b-input-group>
        <b-form-input
          v-model="password"
          type="password"
          :state="$v.password.$error? false : null"
          @input="$v.password.$reset()"
        ></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-form-group class="text-right">
      <b-button type="submit" variant="primary" block :disabled="loading">
        <span v-show="!loading">Zaloguj się</span>
        <span v-show="loading">
          <b-spinner small label="Loading..."></b-spinner>
        </span>
      </b-button>
      <b-button variant="link" @click="goto('/public/forgotPassword')">Zapomniałem hasła</b-button>
    </b-form-group>
  </b-form>
</template>

<script>
import { axios, tokenStore, eventBus } from "@/_infrastructure";
import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false
    };
  },
  validations: {
    username: {
      required,
      email
    },
    password: {
      required
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.loading = true;
        axios
          .post("/auth/login/portal", {
            username: this.username,
            password: this.password
          })
          .then(res => {
            tokenStore.setToken(res.data.token);
            this.$router.push({ path: "/site" });
          })
          .catch(error => {
            eventBus.$emit("unhandled-error", error);
          })
          .then(() => (this.loading = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>
